import { IFilterStore } from '@/models/filter.model';
import { PersistentStore } from './main';
import { thoughtStore } from '@/store/thought-store';
import { RouteLocationNormalizedLoaded } from 'vue-router';
import useHashParams from '@/composables/general/useHashParams';

class FilterStore extends PersistentStore<IFilterStore> {
  protected data(): IFilterStore {
    return {
      defaultFields: [],
      attributeFields: [],
      DefaultValues: new Map(),
      SelectedValues: new Map(),
      fields: [],
    };
  }

  setDefaultFields(fields: any) {
    this.state.defaultFields = fields;
  }
  setAttributeFields(fields: any) {
    this.state.attributeFields = fields;
  }
  setFields(fields: any) {
    this.state.fields = fields;
  }
  setDefaultValues(values: any) {
    const tmpMap = new Map();
    for (const [key, value] of Object.entries(values)) {
      tmpMap.set(key, value);
    }
    this.state.DefaultValues = tmpMap;
    this.state.SelectedValues = tmpMap;
  }
  setSelectedValues(values: any) {
    const tmpMap = new Map();
    for (const [key, value] of Object.entries(values)) {
      tmpMap.set(key, value);
    }
    this.state.SelectedValues = tmpMap;
  }
  resetFilter(values: any, route: RouteLocationNormalizedLoaded) {
    const { setHashParams } = useHashParams(route);
    setHashParams(values, true);
    thoughtStore.setThoughtFilter(values);
    this.state.SelectedValues = this.state.DefaultValues;
  }
  setSelectedFilter(values: any, route: RouteLocationNormalizedLoaded, refresh = true) {
    const { setHashParams } = useHashParams(route);
    setHashParams(values, refresh);
    thoughtStore.setThoughtFilter(values);
    this.setSelectedValues(values);
  }
  setIndividualFilter(values: { key: string; value: string }, route: RouteLocationNormalizedLoaded, refresh = true) {
    const { setHashParams } = useHashParams(route);
    this.state.SelectedValues.set(values.key, values.value);
    setHashParams(Object.fromEntries(this.state.SelectedValues), refresh);
    thoughtStore.setThoughtFilter(Object.fromEntries(this.state.SelectedValues));
  }
}

export const filterStore: FilterStore = new FilterStore('FILTER_STORE');
